import React from 'react';

const Integrations: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <section className="pt-24 pb-12 bg-gradient-to-br from-indigo-50 via-white to-blue-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Integrations</h1>
          <p className="text-gray-600 max-w-3xl">
            CosmaComply integrates with commonly used compliance and operational systems to support data exchange and interoperability.
            Contact us for specific integrations and roadmaps.
          </p>

          <div className="grid md:grid-cols-3 gap-6 mt-10">
            <div className="bg-white border border-gray-200 rounded-lg p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Data Import/Export</h3>
              <p className="text-gray-600 text-sm">CSV/Excel templates, PDF/XML generation, and API endpoints.</p>
            </div>
            <div className="bg-white border border-gray-200 rounded-lg p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">APIs</h3>
              <p className="text-gray-600 text-sm">REST endpoints for facilities, products, adverse events, and submissions.</p>
            </div>
            <div className="bg-white border border-gray-200 rounded-lg p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Webhooks</h3>
              <p className="text-gray-600 text-sm">Event notifications for workflow transitions and data updates.</p>
            </div>
          </div>

          <p className="text-xs text-gray-500 mt-8">Note: Integrations are subject to change. CosmaComply is not affiliated with or approved by the FDA.</p>
        </div>
      </section>
    </div>
  );
};

export default Integrations;
